import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import PropTypes from "prop-types";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const CheckboxesTags = ({ label, placeholder, options, onChange, loadingText, value, limitTags, maxWidth }) => {

    const renderOptionLabel = (option) => option.name;
    const renderOption = (option, { selected }) => (
        <>
            <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={value?.some(val => val.id === option.id) || selected}
            />
            {option.name}
        </>
    )

    return (
        <Autocomplete
            size="small"
            multiple
            fullWidth
            limitTags={limitTags || 2}
            options={options}
            onChange={onChange}
            disableCloseOnSelect
            value={value}
            getOptionLabel={renderOptionLabel}
            renderOption={renderOption}
            style={{ maxWidth: maxWidth || 400  }}
            loadingText={loadingText}
            renderInput={(params) => (
                <TextField
                    {...params}
                    margin="normal"
                    variant="standard"
                    label={label}
                    placeholder={placeholder}
                />
            )}
        />
    );
}

CheckboxesTags.propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    loadingText: PropTypes.string,
    limitTags: PropTypes.number,
    value: PropTypes.array,
    maxWidth: PropTypes.string,
    options: PropTypes.array,
    onChange: PropTypes.func
};

export default CheckboxesTags;
